import { api } from './api';

export interface Comment {
  id: string;
  workspaceId: string;
  targetKind: string;
  targetId: string;
  authorUserId: string;
  body: string;
  mentions: string[];
  createdAt: string;
}

export const commentsApi = {
  list: async (workspaceId: string, targetKind: string, targetId: string): Promise<Comment[]> => {
    const r = await api.get<Comment[]>(`/api/workspaces/${workspaceId}/comments`, {
      params: { targetKind, targetId },
    });
    return r.data;
  },
  create: async (workspaceId: string, input: { targetKind: string; targetId: string; body: string }): Promise<Comment> => {
    const r = await api.post<Comment>(`/api/workspaces/${workspaceId}/comments`, input);
    return r.data;
  },
  update: async (workspaceId: string, id: string, body: string): Promise<Comment> => {
    const r = await api.patch<Comment>(`/api/workspaces/${workspaceId}/comments/${id}`, { body });
    return r.data;
  },
  remove: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/api/workspaces/${workspaceId}/comments/${id}`);
  },
};
